<template>
  <div>
    <b-modal
      v-model="modal"
      hide-footer
      title="Importar Empleados"
      @close="close"
    >
      <p>Importe empleados desde un archivo .csv</p>
      <b-form-file
        v-model="file"
        :state="Boolean(file)"
        placeholder="Elija un archivo o suéltelo aquí..."
        drop-placeholder="Suelta el archivo aquí..."
        browse-text="Navegar"
        accept=".csv"
      />
      <b-button
        class="mt-1 mr-1"
        variant="primary"
        @click="importar()"
      >Importar</b-button>
    </b-modal>

    <b-modal
      v-model="conflictosModal"
      size="lg"
      hide-footer
      title="Conflictos de identidad detectados"
      no-close-on-backdrop
      @close="closeConflictos"
    >
      <b-alert
        show
        variant="danger"
        class="mb-1"
      >
        <div class="alert-body">
          <feather-icon
            icon="AlertTriangleIcon"
            class="mr-50"
          />
          <strong>No se ha importado ningún empleado.</strong>
          {{ conflictosMessage || 'Hay empleados en el CSV cuyo DNI/NIE ya está registrado en el sistema con otra matrícula.' }}
        </div>
      </b-alert>

      <p class="text-muted small mb-1">
        Revisa estas filas en el CSV: el documento ya pertenece a otro empleado registrado.
      </p>

      <b-table
        :items="conflictos"
        :fields="conflictosFields"
        small
        striped
        responsive
        class="mb-1"
      >
        <template #cell(tipo)="data">
          <b-badge :variant="data.item.tipo === 'dni' ? 'primary' : 'info'">
            {{ data.item.tipo.toUpperCase() }}
          </b-badge>
        </template>
        <template #cell(identificador)="data">
          <code>{{ data.item.identificador }}</code>
        </template>
        <template #cell(matricula_bd)="data">
          <strong>{{ data.item.matricula_bd }}</strong>
          <div class="small text-muted">{{ data.item.nombre_bd }}</div>
        </template>
        <template #cell(matricula_csv)="data">
          <strong class="text-danger">{{ data.item.matricula_csv }}</strong>
          <div class="small text-muted">{{ data.item.nombre_csv }}</div>
        </template>
      </b-table>

      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          @click="closeConflictos"
        >Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BButton, BFormFile, BTable, BAlert, BBadge,
} from 'bootstrap-vue'

import store from '@/store'
import empleadoStoreModule from '@/views/system/empleado/empleadoStoreModule'
import { onUnmounted } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BButton,
    BFormFile,
    BTable,
    BAlert,
    BBadge,
  },
  props: {
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      modal: false,
      file: null,
      conflictosModal: false,
      conflictos: [],
      conflictosMessage: '',
      conflictosFields: [
        { key: 'tipo', label: 'Tipo' },
        { key: 'identificador', label: 'Documento' },
        { key: 'matricula_bd', label: 'Matrícula en sistema' },
        { key: 'matricula_csv', label: 'Matrícula en CSV' },
      ],
    }
  },
  watch: {
    show() {
      this.modal = this.show
    },
  },
  methods: {
    close() {
      this.modal = false
      this.$emit('closeModal')
    },
    closeConflictos() {
      this.conflictosModal = false
      this.conflictos = []
      this.conflictosMessage = ''
    },
    importar() {
      store.dispatch('app-empleado/importEmpleados', this.file)
        .then(result => {
          if (result && result.ok === false && Array.isArray(result.conflictos) && result.conflictos.length) {
            this.conflictos = result.conflictos
            this.conflictosMessage = result.message || ''
            this.conflictosModal = true
            this.close()
            return
          }
          this.close()
        })
    },
  },
  setup() {
    const EMPLEADO_APP_STORE_MODULE_NAME = 'app-empleado'

    // Register module
    if (!store.hasModule(EMPLEADO_APP_STORE_MODULE_NAME)) store.registerModule(EMPLEADO_APP_STORE_MODULE_NAME, empleadoStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(EMPLEADO_APP_STORE_MODULE_NAME)) store.unregisterModule(EMPLEADO_APP_STORE_MODULE_NAME)
    })
  },
}
</script>
